<template>
	<div class="curriculum">
		<div v-loading.fullscreen.lock="loading" class="curriculumCon">
			<div class="container">
				<div class="perInfo">
					<div v-if="editInfo==0" class="infoShow">
						<div class="left">
							<div class="name">
								{{userInfo.user_name}}
								<i class="el-icon-edit-outline" style="font-size: 24px;" @click="edit('info')"></i>
							</div>
							<div class="profile">
								<div class="profileLi">
									<img src="@/static/yearIcon.png" class="icon" />
									<div>{{userInfo.work_year}}</div>
								</div>
								<div class="profileLi">
									<img src="@/static/eduIcon.png" class="icon" />
									<div>{{userInfo.qualifications}}</div>
								</div>
								<div class="profileLi">
									<img src="@/static/ageIcon.png" class="icon" />
									<div>{{userInfo.birthday}}</div>
								</div>
							</div>
							<div v-if="userInfo.phone" class="profileLi">
								<img src="@/static/phoneIcon.png" class="icon" />
								<div>{{userInfo.phone.slice(0, 3) + '****' + userInfo.phone.slice(7)}}</div>
							</div>
						</div>
						<div class="right">
							<el-image :src="userInfo.avatar" fit="cover" class="avatar"></el-image>
							<img v-if="userInfo.sex==0" src="@/static/male.png" class="gender" />
							<img v-else src="@/static/female.png" class="gender" />
						</div>
					</div>

					<div v-else class="editShow">
						<div class="editTitle">
							编辑个人信息
						</div>
						<div class="form">
							<el-form :model="ruleForm" ref="infoForm" :rules="infoRules" label-width="100px"
								label-position='top' :inline="true" class="demo-ruleForm">
								<el-form-item label="姓名" prop="user_name">
									<el-input v-model="ruleForm.user_name" style="width: 300px;"></el-input>
								</el-form-item>

								<el-form-item label="性别" prop="sex">
									<div class="gender">
										<div class="button" :class="{active:ruleForm.sex==0}" @click="ruleForm.sex=0">
											男
										</div>
										<div class="button" :class="{active:ruleForm.sex==1}" @click="ruleForm.sex=1">
											女
										</div>
									</div>
								</el-form-item>

								<el-form-item label="出生年月" prop="birthday">
									<el-date-picker v-model="ruleForm.birthday" type="date" format='yyyy-MM-dd'
										value-format='yyyy-MM-dd' placeholder="选择日期"
										style="width: 300px;"></el-date-picker>
								</el-form-item>

								<el-form-item label="学历" prop="qualifications">
									<el-select v-model="ruleForm.qualifications" placeholder="请选择"
										style="width: 300px;">
										<el-option v-for="(item,index) of eduList" :key="index" :label="item"
											:value="item"></el-option>
									</el-select>
								</el-form-item>

								<el-form-item label="工作经验" prop="work_year">
									<el-select v-model="ruleForm.work_year" placeholder="请选择" style="width: 300px;">
										<el-option v-for="(item,index) of expList" :key="index" :label="item"
											:value="item"></el-option>
									</el-select>
								</el-form-item>

								<el-form-item label="电话号码" prop="phone">
									<el-input v-model="ruleForm.phone" style="width: 300px;"></el-input>
								</el-form-item>

							</el-form>

							<el-form :model="ruleForm" ref="ruleForm" label-width="100px" label-position='top'
								:inline="true" class="demo-ruleForm">
								<el-form-item label="上传头像" prop="avatar">
									<el-upload class="avatars-uploader"
										action="https://zhunpin.work/api/admin/Qiniu/uploadImage"
										:show-file-list="false" :on-success="handleSu">
										<img v-if="ruleForm.avatar" :src="ruleForm.avatar" class="avatars">
										<i v-else class="el-icon-plus avatars-uploader-icon"></i>
									</el-upload>
								</el-form-item>
							</el-form>
						</div>

						<div class="buttonG">
							<el-button v-if="editInfo==1" @click="editInfo=0">取消</el-button>
							<el-button type="primary" @click="saveInfo('info')">完成</el-button>
						</div>

					</div>
				</div>

				<!-- 期望职位 -->
				<div class="model">
					<div v-if="editExpect==0" class="show">
						<div class="lookUp">
							<div class="line"></div>
							<div>
								期望职位
							</div>
							<i class="el-icon-edit-outline" style="font-size: 24px;" @click="edit('expect')"></i>
						</div>
						<div class="expectShow">
							<div class="top">
								<div class="name">
									{{userInfo.position_type}}
								</div>
								<div>
									{{`${parseFloat((userInfo.salary_min/1000).toFixed(1))}-${parseFloat((userInfo.salary_max/1000).toFixed(1))}k`}}
								</div>
							</div>
							<div v-if="userInfo.living_place" class="bottom">
								{{userInfo.living_place}} · {{userInfo.salary_type}} · {{userInfo.job_intension}}
							</div>
						</div>
					</div>

					<div v-else class="editShow">
						<div class="editTitle">
							编辑求职期望
						</div>
						<div class="form">
							<el-form :model="ruleForm" :rules="expectRules" ref="expectForm" label-width="100px"
								label-position='top' :inline="true" class="demo-ruleForm">

								<el-form-item label="期望职位" prop="position_type_id">
									<el-cascader :options="positionList" filterable :show-all-levels="false" :props="positionProps"
										style="width: 260px;" v-model="ruleForm.position_type_id"
										@change="positionType($event)"></el-cascader>
								</el-form-item>

								<el-form-item label="工作城市" prop="living_place">
									<!-- <el-cascader :options="cityList" filterable :show-all-levels="true"
										:props="cityProps" style="width: 260px;"
										v-model="ruleForm.living_place"></el-cascader> -->
										
									<el-select v-model="ruleForm.living_place" filterable placeholder="请选择"
										style="width: 260px;">
										<el-option v-for="(item,index) of cityList" :key="index" :label="item.name"
											:value="item.name"></el-option>
									</el-select>
								</el-form-item>

								<el-form-item label="到岗时间" prop="job_intension">
									<el-select v-model="ruleForm.job_intension" placeholder="请选择" style="width: 260px;">
										<el-option v-for="(item,index) of arrivalList" :key="index" :label="item"
											:value="item"></el-option>
									</el-select>
								</el-form-item>

								<el-form-item label="结算方式" prop="salary_type">
									<el-select v-model="ruleForm.salary_type" placeholder="请选择" style="width: 260px;">
										<el-option v-for="(item,index) of settleList" :key="index" :label="item"
											:value="item"></el-option>
									</el-select>
								</el-form-item>

								<el-form-item label="最低薪资" prop='salary_min' style="margin-right: 0;">
									<el-select v-model="ruleForm.salary_min" placeholder="最低薪资" style="width: 260px;"
										@change="handleMinSalaryChange">
										<el-option v-for="minSalary in minArray" :key="minSalary.value"
											:label="minSalary.label" :value="minSalary.value"></el-option>
									</el-select>
									<span style="margin: 0 8px;">-</span>
								</el-form-item>

								<el-form-item label="最高薪资" prop='salary_max' style="margin-right: 0;">
									<el-select v-model="ruleForm.salary_max" placeholder="最高薪资" style="width: 260px;">
										<el-option v-for="maxSalary in availableMaxSalaries" :key="maxSalary.value"
											:label="maxSalary.label" :value="maxSalary.value"></el-option>
									</el-select>
								</el-form-item>

							</el-form>

						</div>

						<div class="buttonG">
							<el-button v-if="editExpect==1" @click="editExpect=0">取消</el-button>
							<el-button type="primary" @click="saveInfo('expect')">完成</el-button>
						</div>
					</div>

				</div>

				<!-- 个人优势 -->
				<div class="model">
					<div v-if="editAdv==0" class="show">
						<div class="lookUp">
							<div class="line"></div>
							<div>
								个人优势
							</div>
							<i class="el-icon-edit-outline" style="font-size: 24px;" @click="edit('adv')"></i>
						</div>
						<div class="advShow">
							{{userInfo.personal_evaluation}}
						</div>
					</div>
					<div v-else class="editShow">
						<div class="editTitle">
							编辑个人优势
						</div>
						<el-form :model="ruleForm" :rules="advRules" ref="advForm" label-width="100px"
							label-position='top' :inline="true" class="demo-ruleForm">
							<el-form-item label="" prop='personal_evaluation' style="margin-right: 0;">
								<el-input type="textarea" class="textarea" :autosize="{ minRows: 6, maxRows: 10}"
									placeholder="请输入内容" v-model="ruleForm.personal_evaluation"></el-input>
							</el-form-item>
						</el-form>

						<div class="buttonG">
							<el-button v-if="editAdv==1" @click="editAdv=0">取消</el-button>
							<el-button type="primary" @click="saveInfo('adv')">完成</el-button>
						</div>
					</div>
				</div>

				<!-- 实习/工作经历 -->
				<div class="model">
					<div v-if="editPractice==0" class="show">
						<div class="lookUp">
							<div class="line"></div>
							<div>
								实习/工作经历
							</div>
							<i class="el-icon-circle-plus-outline" style="font-size: 24px;"
								@click="add('practice')"></i>
						</div>
						<div v-for="(item,index) of userInfo.work" :key="index" class="practiceShow">
							<div class="cor">
								<div class="name">
									{{item.belong_to}}
								</div>
								<div class="time">
									{{item.start_time}}-{{item.end_time}}
									<i class="el-icon-edit-outline" style="font-size: 24px;"
										@click="edit('practice',item)"></i>
									<i class="el-icon-delete" style="font-size: 24px;" @click="remove(item.id)"></i>
								</div>
							</div>
							<div class="praPos">
								{{item.position}}
							</div>
							<div class="praContent">
								内容：{{item.descrption}}
							</div>
							<div class="reason">
								离职原因：{{item.remark}}
							</div>
						</div>
					</div>

					<div v-else class="editShow">
						<div class="editTitle">
							编辑实习/工作经历
						</div>
						<div class="form">
							<el-form :model="workForm" :rules="workRules" ref="workForm" label-width="100px"
								label-position='top' :inline="true" class="demo-ruleForm">
								<el-form-item label="公司名称" prop="belong_to">
									<el-input v-model="workForm.belong_to" style="width: 300px;"></el-input>
								</el-form-item>

								<el-form-item label="在职时间" prop="time">
									<el-date-picker v-model="workForm.time" type="monthrange" range-separator="至"
										format="yyyy-MM" value-format="yyyy-MM" start-placeholder="开始日期"
										end-placeholder="结束日期" @change="changeTime">
									</el-date-picker>
								</el-form-item>

								<el-form-item label="工作岗位" prop="position">
									<el-input v-model="workForm.position" style="width: 300px;"></el-input>
								</el-form-item>

								<el-form-item label="工作内容" prop="descrption" style="margin-right: 0;">
									<el-input type="textarea" class="textarea" :autosize="{ minRows: 6, maxRows: 10}"
										placeholder="请输入内容" v-model="workForm.descrption"></el-input>
								</el-form-item>

								<el-form-item label="离职原因" prop="remark" style="margin-right: 0;">
									<el-input type="textarea" class="textarea" :autosize="{ minRows: 6, maxRows: 10}"
										placeholder="请输入内容" v-model="workForm.remark"></el-input>
								</el-form-item>
							</el-form>
						</div>
						<div class="buttonG">
							<el-button v-if="editPractice==1" @click="editPractice=0">取消</el-button>
							<el-button type="primary" @click="saveInfo('practice')">完成</el-button>
						</div>
					</div>
				</div>

				<!-- 项目经历 -->
				<div class="model">
					<div v-if="editItem==0" class="show">
						<div class="lookUp">
							<div class="line"></div>
							<div>
								项目经历
							</div>
							<i class="el-icon-circle-plus-outline" style="font-size: 24px;" @click="add('item')"></i>
						</div>
						
						<div v-for="(item,index) of userInfo.project" :key="index" class="practiceShow">
							<div class="cor">
								<div class="name">
									{{item.belong_to}}
								</div>
								<div class="time">
									{{item.start_time}}-{{item.end_time}}
									<i class="el-icon-edit-outline" style="font-size: 24px;"
										@click="edit('item',item)"></i>
									<i class="el-icon-delete" style="font-size: 24px;" @click="remove(item.id)"></i>
								</div>
							</div>
							<div class="praPos">
								{{item.position}}
							</div>
							<div class="praContent">
								项目描述：{{item.descrption}}
							</div>
							<div v-if="item.remark" class="reason">
								备注：{{item.remark}}
							</div>
						</div>
						
					</div>

					<div v-else class="editShow">
						<div class="editTitle">
							编辑项目经历
						</div>
						<div class="form">
							<el-form :model="workForm" :rules="workRules" ref="workForm" label-width="100px"
								label-position='top' :inline="true" class="demo-ruleForm">
								<el-form-item label="项目名称" prop="belong_to">
									<el-input v-model="workForm.belong_to" style="width: 300px;"></el-input>
								</el-form-item>
							
								<el-form-item label="项目时间" prop="time">
									<el-date-picker v-model="workForm.time" type="monthrange" range-separator="至"
										format="yyyy-MM" value-format="yyyy-MM" start-placeholder="开始日期"
										end-placeholder="结束日期" @change="changeTime">
									</el-date-picker>
								</el-form-item>
							
								<el-form-item label="担当职务" prop="position">
									<el-input v-model="workForm.position" style="width: 300px;"></el-input>
								</el-form-item>
							
								<el-form-item label="项目描述" prop="descrption" style="margin-right: 0;">
									<el-input type="textarea" class="textarea" :autosize="{ minRows: 6, maxRows: 10}"
										placeholder="请输入内容" v-model="workForm.descrption"></el-input>
								</el-form-item>
							
								<el-form-item label="备注" prop="remarks" style="margin-right: 0;">
									<el-input type="textarea" class="textarea" :autosize="{ minRows: 6, maxRows: 10}"
										placeholder="请输入内容" v-model="workForm.remark"></el-input>
								</el-form-item>
							</el-form>
							
						</div>
						<div class="buttonG">
							<el-button v-if="editItem==1" @click="editItem=0">取消</el-button>
							<el-button type="primary" @click="saveInfo('item')">完成</el-button>
						</div>
					</div>

				</div>

				<!-- 教育经历 -->
				<div class="model">
					<div v-if="editEdu==0" class="show">
						<div class="lookUp">
							<div class="line"></div>
							<div>
								教育经历
							</div>
							<i class="el-icon-circle-plus-outline" style="font-size: 24px;" @click="add('edu')"></i>
						</div>
						
						<div v-for="(item,index) of userInfo.education" :key="index" class="practiceShow">
							<div class="cor">
								<div class="name">
									{{item.belong_to}}
								</div>
								<div class="time">
									{{item.start_time}}-{{item.end_time}}
									<i class="el-icon-edit-outline" style="font-size: 24px;" @click="edit('edu',item)"></i>
									<i class="el-icon-delete" style="font-size: 24px;" @click="remove(item.id)"></i>
								</div>
							</div>
							<div class="praPos">
								{{item.position}}
							</div>
							<div v-if='item.descrption' class="praContent">
								获奖情况：{{item.descrption}}
							</div>
							<div v-if="item.remark" class="reason">
								备注：{{item.remark}}
							</div>
						</div>
						
					</div>

					<div v-else class="editShow">
						<div class="editTitle">
							编辑教育经历
						</div>
						<div class="form">
							<el-form :model="ruleForm" ref="ruleForm" label-width="100px" label-position='top'
								:inline="true" class="demo-ruleForm">
								
								<el-form :model="workForm" :rules="workRules" ref="workForm" label-width="100px"
									label-position='top' :inline="true" class="demo-ruleForm">
									<el-form-item label="学校名称" prop="belong_to">
										<el-input v-model="workForm.belong_to" style="width: 300px;"></el-input>
									</el-form-item>
								
									<el-form-item label="就读时间" prop="time">
										<el-date-picker v-model="workForm.time" type="monthrange" range-separator="至"
											format="yyyy-MM" value-format="yyyy-MM" start-placeholder="开始日期"
											end-placeholder="结束日期" @change="changeTime">
										</el-date-picker>
									</el-form-item>
								
									<el-form-item label="就读专业" prop="position">
										<el-input v-model="workForm.position" style="width: 300px;"></el-input>
									</el-form-item>
								
									<el-form-item label="获奖概况" prop="descrptions" style="margin-right: 0;">
										<el-input type="textarea" class="textarea" :autosize="{ minRows: 6, maxRows: 10}"
											placeholder="请输入内容" v-model="workForm.descrption"></el-input>
									</el-form-item>
								
									<el-form-item label="备注" prop="remarks" style="margin-right: 0;">
										<el-input type="textarea" class="textarea" :autosize="{ minRows: 6, maxRows: 10}"
											placeholder="请输入内容" v-model="workForm.remark"></el-input>
									</el-form-item>
								</el-form>
								
							</el-form>
						</div>
						<div class="buttonG">
							<el-button v-if="editEdu==1" @click="editEdu=0">取消</el-button>
							<el-button type="primary" @click="saveInfo('edu')">完成</el-button>
						</div>
					</div>
				</div>

			</div>
			<downCode></downCode>
		</div>

	</div>
</template>

<script>
	import downCode from '@/components/downCode.vue'
	import { eduList, expList, minArray, maxArray } from '@/unit/disposition.js';
	export default {
		name: 'curriculum',
		components: {
			downCode
		},
		data() {
			return {
				ruleForm: {
					user_name: '',
					avatar: '',
					sex: 0,
					phone: '',
					qualifications: '',
					birthday: '',
					work_year: '',
					position_type_id: '',
					living_place: [],
					job_intension: '',
					salary_type: '',
					salary_min: '',
					salary_max: '',
					position_type: '',
					personal_evaluation: '',
				},
				workForm: {
					start_time: '',
					end_time: '',
					belong_to: '',
					position: '',
					descrption: '',
					remark: '',
					time: [],
				}, //项目表单
				addType: 1, //类型（1=工作经历，2=项目经历，3=教育经历)
				userInfo: '', //个人信息
				editInfo: 0, //修改信息状态 0关闭状态修改的状态 1是修改 2是初始
				infoRules: {
					user_name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}, ],
					birthday: [{
						required: true,
						message: '请输入选择出生年月',
						trigger: 'blur'
					}, ],
					qualifications: [{
						required: true,
						message: '请输入选择学历',
						trigger: 'blur'
					}, ],
					work_year: [{
						required: true,
						message: '请输入工作经验',
						trigger: 'blur'
					}, ],
					phone: [{
							required: true,
							message: '请输入手机号',
							trigger: 'blur'
						},
						{
							validator: this.validatePhoneNumber,
							trigger: 'blur',
						},
					],
				},
				editExpect: 0, //修改求职期望状态
				expectRules: {
					position_type_id: [{
						required: true,
						message: '请选择期望职位',
						trigger: 'blur'
					}, ],
					living_place: [{
						required: true,
						message: '请选择工作城市',
						trigger: 'blur'
					}, ],
					job_intension: [{
						required: true,
						message: '请选择到岗时间',
						trigger: 'blur'
					}, ],
					salary_type: [{
						required: true,
						message: '请选择结算方式',
						trigger: 'blur'
					}, ],
					salary_min: [{
						required: true,
						message: '请选择最低薪资',
						trigger: 'blur'
					}, ],
					salary_max: [{
						required: true,
						message: '请选择最高薪资',
						trigger: 'blur'
					}, ],
				},
				editAdv: 0, //修改优势状态
				advRules: {
					personal_evaluation: [{
						required: true,
						message: '请输入',
						trigger: 'blur'
					}, ],
				},
				editPractice: 0, //修改实习状态
				editItem: 0, //修改项目状态
				editEdu: 0, //修改教育状态
				editId: '', //修改项目的id
				workRules: {
					belong_to: [{
						required: true,
						message: '请输入',
						trigger: 'blur'
					}, ],
					time: [{
						required: true,
						message: '请选择',
						trigger: 'blur'
					}, ],
					position: [{
						required: true,
						message: '请输入',
						trigger: 'blur'
					}, ],
					descrption: [{
						required: true,
						message: '请输入',
						trigger: 'blur'
					}, ],
					remark: [{
						required: true,
						message: '请输入',
						trigger: 'blur'
					}, ]
				},
				eduList: eduList,
				expList: expList,
				typeList: ['社招', '实习生招聘', '兼职招聘'],
				arrivalList: ['可立即到岗', '可一周内到岗', '可一月内到岗'],
				settleList: ['日结', '周结', '半月结', '月结', '项目结'],
				cityList: [],
				cityProps: {
					value: 'name',
					label: 'name',
					children: 'city',
					emitPath: true
				},
				positionList: [],
				positionProps: {
					value: 'id',
					label: 'type_name',
					children: 'child',
					emitPath: false
				},
				minArray: minArray,
				maxArray: maxArray,
				loading: false,
			}
		},
		computed: {
			availableMaxSalaries() {
				// 在最高薪资选项中剔除低于最低薪资的选项
				if (this.ruleForm.salary_min) {
					return this.maxArray.filter((salary) => salary.value > this.ruleForm.salary_min);
				} else {
					return this.maxArray;
				}
			},
		},
		created() {
			this.getUserInfo()
			this.getCity()
			this.getPosition()
		},
		methods: {
			// 时间的变化
			changeTime(e) {
				this.workForm.start_time = e[0]
				this.workForm.end_time = e[1]
			},
			//选择职位如何赋值position_tyoe
			positionType(e) {
				this.ruleForm.position_type = this.findChildById(this.positionList, e).type_name
			},
			// 查找position_tyoe
			findChildById(tree, targetId) {
				for (const node of tree) {
					if (node.id === targetId) {
						return node;
					}
					if (node.child) {
						const foundChild = this.findChildById(node.child, targetId);
						if (foundChild) {
							return foundChild;
						}
					}
				}
				return null;
				return null;
			},
			// 手机号验证
			validatePhoneNumber(rule, value, callback) {
				const reg = /^[1][3-9][0-9]{9}$/;
				if (reg.test(value)) {
					callback();
				} else {
					callback(new Error('请输入有效的手机号'));
				}
			},
			handleMinSalaryChange() {
				// 处理最低薪资变化
				if (this.ruleForm.salary_max && this.ruleForm.salary_min > this.ruleForm.salary_max) {
					this.ruleForm.salary_max = null;
				}
			},
			// 获取省市区
			getCity() {
				this.$axios.get('/api/client/Common/getAreaSeparate',{params:{level:2}}).then(res => {
					if (res.code == 200) {
						this.cityList = res.data
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			//获取职位
			getPosition() {
				this.$axios.get('/api/client/Common/getPositionType').then(res => {
					if (res.code == 200) {
						this.positionList = res.data
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			// 图片上传完成回调
			handleSu(res, file) {
				console.log(res, '----res, file')
				if (res.code == 200) {
					this.ruleForm.avatar = res.data
				}
			},
			// 获取简历
			getUserInfo() {
				this.$axios.get('/api/client/User/resumeDetails').then(res => {
					if (res.code == 200) {
						if (!res.data.user_name) {
							this.editInfo = 2
						}
						if (!res.data.position_type_id) {
							this.editExpect = 2
						}
						if (!res.data.personal_evaluation) {
							this.editAdv = 2
						}
						this.userInfo = res.data
						this.loading = false
					} else {
						this.loading = false
						this.$eltips(res.msg, 'error')
					}
				})
			},
			add(type) {
				this.editId = ''
				this.workForm = {
					start_time: '',
					end_time: '',
					belong_to: '',
					position: '',
					descrption: '',
					remark: '',
					time: []
				}
				switch (type) {
					case 'practice':
						this.addType = 1
						this.editPractice = 1
						break;
					case 'item':
						this.addType = 2
						this.editItem = 1
						break;
					case 'edu':
						this.addType = 3
						this.editEdu = 1
						break;
				}
			},
			remove(id) {
				this.$confirm('确认删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true
					this.$axios.post('/api/client/User/destroyExperience', {id:id}).then(res => {
						if (res.code == 200) {
							this.getUserInfo()
							this.loading = false
							this.$eltips('保存成功')
						} else {
							this.loading = false
							this.$eltips(res.msg, 'error')
						}
					})
				}).catch(() => {});
			},
			// 修改
			edit(type, item) {
				switch (type) {
					case 'info': //个人资料
						this.editInfo = 1
						this.ruleForm.user_name = this.userInfo.user_name
						this.ruleForm.avatar = this.userInfo.avatar
						this.ruleForm.sex = this.userInfo.sex
						this.ruleForm.phone = this.userInfo.phone
						this.ruleForm.qualifications = this.userInfo.qualifications
						this.ruleForm.birthday = this.userInfo.birthday
						this.ruleForm.work_year = this.userInfo.work_year
						break;
					case 'expect': //期望职位
						this.editExpect = 1
						this.ruleForm.position_type_id = this.userInfo.position_type_id
						this.ruleForm.living_place = this.userInfo.living_place
						this.ruleForm.job_intension = this.userInfo.job_intension
						this.ruleForm.salary_type = this.userInfo.salary_type
						this.ruleForm.salary_min = this.userInfo.salary_min / 1000
						this.ruleForm.salary_max = this.userInfo.salary_max / 1000
						this.ruleForm.position_type = this.userInfo.position_type
						break;
					case 'adv': //个人优势
						this.editAdv = 1
						this.ruleForm.personal_evaluation = this.userInfo.personal_evaluation
						break;
					case 'practice': //经历合集
						this.editId = item.id
						this.addType = 1
						this.editPractice = 1
						this.workForm = {
							start_time: item.start_time,
							end_time: item.end_time,
							belong_to: item.belong_to,
							position: item.position,
							descrption: item.descrption,
							remark: item.remark,
							time: [item.start_time, item.end_time]
						}
					break;
					case 'item':
					    this.editId = item.id
						this.addType = 2
						this.editItem = 1
						this.workForm = {
							start_time: item.start_time,
							end_time: item.end_time,
							belong_to: item.belong_to,
							position: item.position,
							descrption: item.descrption,
							remark: item.remark,
							time: [item.start_time, item.end_time]
						}
					break;
					case 'edu':
					   this.editId = item.id
					   this.addType = 3
					   this.editEdu = 1
					   this.workForm = {
					   	start_time: item.start_time,
					   	end_time: item.end_time,
					   	belong_to: item.belong_to,
					   	position: item.position,
					   	descrption: item.descrption,
					   	remark: item.remark,
					   	time: [item.start_time, item.end_time]
					   }
					break;
				}
			},
			// 保存
			saveInfo(type) {
				let data = {}
				if (type == 'info') {
					this.$refs['infoForm'].validate((valid) => {
						if (valid) {
							data.user_name = this.ruleForm.user_name
							data.avatar = this.ruleForm.avatar
							data.sex = this.ruleForm.sex
							data.phone = this.ruleForm.phone
							data.qualifications = this.ruleForm.qualifications
							data.birthday = this.ruleForm.birthday
							data.work_year = this.ruleForm.work_year
							this.savaRequest(type, data)
						} else {
							console.log('error')
							return;
						}
					});
				}

				if (type == 'expect') {
					this.$refs['expectForm'].validate((valid) => {
						if (valid) {
							data.position_type_id = this.ruleForm.position_type_id
							data.living_place = this.ruleForm.living_place
							data.job_intension = this.ruleForm.job_intension
							data.salary_type = this.ruleForm.salary_type
							data.salary_min = this.ruleForm.salary_min * 1000
							data.salary_max = this.ruleForm.salary_max * 1000
							data.position_type = this.ruleForm.position_type
							this.savaRequest(type, data)
						} else {
							console.log('error')
							return;
						}
					});
				}

				if (type == 'adv') {
					this.$refs['advForm'].validate((valid) => {
						if (valid) {
							data.personal_evaluation = this.ruleForm.personal_evaluation
							this.savaRequest(type, data)
						} else {
							console.log('error')
							return;
						}
					});
				}


				if (type == 'practice' || type == 'item' || type == 'edu') {
					this.$refs['workForm'].validate((valid) => {
						if (valid) {
							data = this.workForm
							delete data.time
							data.type = this.addType
							if (this.editId) {
								data.id = this.editId
							}
							this.addEdit(type, data)
						} else {
							console.log('error')
							return;
						}
					});
				}

			},
			savaRequest(type, data) {
				this.loading = true
				this.$axios.post('/api/client/User/edit', data).then(res => {
					if (res.code == 200) {
						this.getUserInfo()
						switch (type) {
							case 'info':
								this.editInfo = 0
								break;
							case 'expect':
								this.editExpect = 0
								break;
							case 'adv':
								this.editAdv = 0
								break;
						}
						this.loading = false
						this.$eltips('保存成功')
					} else {
						this.loading = false
						this.$eltips(res.msg, 'error')
					}
				})
			},

			addEdit(type, data) {
				this.loading = true
				let url = ''
				if (this.editId) {
					url = '/api/client/User/editUserExperience'
				} else {
					url = '/api/client/User/createUserExperience'
				}
				this.$axios.post(url, data).then(res => {
					if (res.code == 200) {
						this.getUserInfo()
						switch (type) {
							case 'practice':
								this.editPractice = 0
								break;
							case 'item':
								this.editItem = 0
								break;
							case 'edu':
								this.editEdu = 0
								break;
						}
						this.loading = false
						this.$eltips('保存成功')
					} else {
						this.loading = false
						this.$eltips(res.msg, 'error')
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.curriculum {
		position: relative;
		padding: 48px 0 38px;
		display: flex;
		justify-content: center;
		box-sizing: border-box;
		.el-form--label-top .el-form-item__label {
			padding: 0 !important;
		}

		.el-form-item {
			margin-right: 20px;
		}

		.el-icon-circle-plus-outline,
		.el-icon-edit-outline {
			cursor: pointer;
			margin-left: 8px;

			&:hover {
				color: #51A190;
			}
		}

		.curriculumCon {
			display: flex;
			// align-items: center;
			width: 1200px;
			position: relative;
			z-index: 2;

			.container {
				flex: 1;
				margin-right: 16px;
				background-color: #FFF;
				padding: 0 32px;

				.editTitle {
					color: #181C2E;
					font-size: 24px;
					font-weight: bold;
					margin-bottom: 32px;
				}

				.buttonG {
					display: flex;
					align-items: center;
					justify-content: flex-end;

					.el-button {
						width: 100px;
						height: 46px;
						border-radius: 16px;
					}
				}


				.perInfo {
					margin-bottom: 40px;

					.infoShow {
						display: flex;
						align-items: center;
						justify-content: space-between;
						padding: 36px 0;

						.left {
							.name {
								display: flex;
								align-items: center;
								font-size: 28px;
								color: #181C2E;
								margin-bottom: 20px;

								.icon {
									width: 24px;
									height: 24px;
									margin-left: 8px;
								}
							}

							.profile {
								display: flex;
								align-items: center;
								margin-bottom: 22px;
							}

							.profileLi {
								display: flex;
								align-items: center;
								color: #5E5E5E;
								font-size: 16px;
								margin-right: 40px;

								.icon {
									width: 21px;
									height: 21px;
									margin-right: 4px;
								}
							}
						}

						.right {
							width: 112px;
							height: 112px;
							position: relative;

							.avatar {
								width: 100%;
								height: 100%;
								border-radius: 50%;
							}

							.gender {
								width: 29px;
								height: 29px;
								position: absolute;
								right: 0;
								bottom: 0;
								border-radius: 50%;
								z-index: 2;
							}
						}
					}

					.editShow {
						padding: 36px 0;

						.form {
							display: flex;

							.gender {
								display: flex;
								align-items: center;

								.button {
									width: 140px;
									line-height: 40px;
									margin-right: 20px;
									border: 1px solid #DCDFE6;
									box-sizing: border-box;
									border-radius: 4px;
									text-align: center;
									cursor: pointer;

									&:last-child {
										margin-right: 0;
									}
								}

								.active {
									border: 1px solid #51A190;
									background-color: rgba(81, 161, 144, 0.10);
									color: #51A190;
								}
							}

							.photo {
								width: 150px;
								height: 150px;
								border-radius: 6px;
								cursor: pointer;
							}
						}

					}
				}


				.model {
					margin-bottom: 40px;

					.lookUp {
						display: flex;
						align-items: center;
						justify-content: space-between;
						color: #181C2E;
						font-size: 20px;
						font-weight: bold;
						margin-bottom: 16px;
						position: relative;

						.icon {
							width: 24px;
							height: 24px;
							cursor: pointer;
						}


						.line {
							width: 4px;
							height: 20px;
							background-color: #9B6CFF;
							border-radius: 16px;
							position: absolute;
							left: -24px;
							top: 50%;
							transform: translate(0, -50%);
							margin-top: 1px;
						}
					}

					.advShow {
						color: #5E5E5E;
						font-size: 16px;
					}

					.expectShow {
						.top {
							display: flex;
							align-items: center;
							font-size: 18px;

							.name {
								color: #181C2E;
								margin-right: 20px;
							}

							margin-bottom: 12px;
						}

						.bottom {
							color: #5E5E5E;
							font-size: 16px;
						}
					}

					.practiceShow {
						margin-bottom: 16px;

						&:last-child {
							margin-bottom: 0;
						}

						.cor {
							display: flex;
							align-items: center;
							justify-content: space-between;
							margin-bottom: 17px;

							.name {
								font-size: 18px;
								color: #181C2E;
								font-weight: bold;
							}

							.time {
								color: #5E5E5E;
								font-size: 15px;
								display: flex;
								align-items: center;

								.icon {
									margin-left: 8px;
								}

								.el-icon-delete {
									margin-left: 8px;
									cursor: pointer;

									&:hover {
										color: red;
									}
								}
							}
						}

						.praPos,
						.praContent,
						.reason {
							color: #5E5E5E;
							font-size: 16px;
							margin-bottom: 16px;
						}

						.reason {
							margin-bottom: 0;
						}
					}

					.editShow {
						.text {
							margin-bottom: 32px;
						}

						.textarea {
							width: 891px;
						}

					}
				}
			}
		}
	}
</style>

<style>
	.avatars-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatars-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatars-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px !important;
		height: 178px !important;
		line-height: 178px !important;
		text-align: center;
	}

	.avatars {
		width: 178px !important;
		height: 178px !important;
		display: block;
	}
</style>